import React from "react";
import { CommonDropdown } from "./CommonDropdown";
import { string, bool, func } from "prop-types";

type VariableSpotDropdownProps = Pick<
  React.ComponentProps<typeof CommonDropdown>,
  "componentLabel" | "defaultValue" | "showAll" | "onChange"
>;

export const VariableSpotDropdown = (props: VariableSpotDropdownProps) => {
  const options = [
    {
      value: "variable",
      label: "Variable",
    },
    {
      value: "spot",
      label: "Spot",
    },
  ];

  const propsDefault = {
    componentLabel: "",
  };

  // Use props directly with fallback instead of state
  const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <CommonDropdown
      options={options}
      componentLabel={componentLabel}
      showAll={props.showAll}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
    />
  );
};

VariableSpotDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  showAll: bool,
  onChange: func,
};
